
import { defineComponent, onBeforeMount, ref } from 'vue';
import { XIcon } from 'vue-feather-icons';
import moment from 'moment';
import axios, { AxiosError } from 'axios';
// eslint-disable-next-line
import router from '@/router';
// import { getPreSignedUrl } from '@/utils/learner_submit_service';
import { invokeGetUserRole } from '@/utils/admin/master_service';
// eslint-disable-next-line
// import SearchBar from '@/components/global/SearchBar.vue';
// eslint-disable-next-line
import { getEdcaseURL, invokeGetProgramDetails, invokeTriggerReport } from '../../utils/admin/program_administration_service';
// eslint-disable-next-line
import { triggerProxyAssignmentForSpecialProgram } from '../../utils/admin/program_administration_service';
import { invokegetAllProgram } from '@/utils/admin/task_management_service';
import { postApi } from '@/utils/ApiCalls';
// import { getPreSignedUrl } from '@/utils/learner_submit_service';

export default defineComponent({
  name: 'ProgramAdministration',
  // components: { XIcon, SearchBar },
  components: { XIcon },
  setup() {
    const openShareModal = ref(false);
    const openShareModalParticipant = ref(false);
    // const ProgramDetails = ref();
    const ProgramDetailsArray = ref();
    const filteredProgramDetails = ref();
    const renderReady = ref();
    const programCheckOne = ref([]);
    const bulkParticipantFileName = ref();
    const bulkParticipantsFile = ref();
    const fileInputKey = ref(0);
    const selectedProgramId = ref();
    const programBtnShow = ref();
    const showParticipant = ref(false);
    const participantList = ref();
    const selectedProgramName = ref();
    const showBulkParticipantPanel = ref(false);
    const errorMessage = ref();
    const successMessage = ref();
    const reportSuccessMessage = ref();
    // const preSignedUrl = ref();
    const userRole = ref();
    const loggedInUser = ref();
    const showScreen = ref(false);
    const showTaskImport = ref(false);
    const showReportBtn = ref(false);
    const edcastBtnShow = ref(false);
    const showBulkBtn = ref(false);
    const showTriggerProxyAssignment = ref(false);
    const programLists = ref();
    const programIdsArr = ref([]);
    const searchProgText = ref('');
    const checkOne = () => {
      programCheckOne.value = [];
    };
    const clearFile = async () => {
      fileInputKey.value += 1;
      bulkParticipantsFile.value = null;
      bulkParticipantFileName.value = null;
    };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const selectedFile = async (event: any) => {
      try {
        const file = event.target.files[0];
        const fileName = file.name;
        const isFileCSV = fileName.endsWith('.csv');
        if (!isFileCSV) {
          errorMessage.value = 'Please Select valid file to upload, only CSV file is allowed';
          setTimeout(() => {
            errorMessage.value = null;
          }, 6000);
          fileInputKey.value += 1;
          bulkParticipantsFile.value = null;
          bulkParticipantFileName.value = null;
        } else {
          bulkParticipantFileName.value = fileName;
          bulkParticipantsFile.value = file;
        }
      } catch (error) {
        console.log(error);
      }
    };
    // const getProgramDetails = async () => {
    //   renderReady.value = false;
    //   // eslint-disable-next-line @typescript-eslint/no-explicit-any
    //   const programDetailsRes: any = await invokeGetProgramDetails('/program');
    //   const filtered = programDetailsRes.data;
    //   // let filtered;
    //   // if (userRole.value.includes('System Admin')) {
    //   //   filtered = allPrograms;
    //   // } else {
    //   //   // eslint-disable-next-line @typescript-eslint/no-explicit-any
    //   //   filtered = allPrograms.filter((el: any) => {
    //   //     const programAdmin = el.program_admin;
    //   //     if (programAdmin) {
    //   //       return programAdmin.includes(loggedInUser.value);
    //   //     }
    //   //     return false;
    //   //   });
    //   // }

    //   // eslint-disable-next-line @typescript-eslint/no-explicit-any
    //   const sortedArray = filtered.sort((a: any, b: any) => moment(b.start_date).utc().unix() - moment(a.start_date).utc().unix());
    //   for (let index = 0; index < sortedArray.length; index += 1) {
    //     const element = sortedArray[index];
    //     element.start_date = moment(element.start_date).format('DD-MM-YYYY');
    //     element.end_date = moment(element.end_date).format('DD-MM-YYYY');
    //   }
    //   ProgramDetails.value = sortedArray;
    //   renderReady.value = true;
    // };
    const getSelectedProgramDetails = async () => {
      renderReady.value = false;
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      const programDetailsRes: any = await postApi('/programs', { programNames: programIdsArr.value });
      // console.log(`programDetailsRes`, { programDetailsRes });
      const filtered = programDetailsRes.data?.data;
      // console.log(filtered, { filtered });
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      const sortedArray = filtered.sort((a: any, b: any) => moment(b.start_date).utc().unix() - moment(a.start_date).utc().unix());
      for (let index = 0; index < sortedArray.length; index += 1) {
        const element = sortedArray[index];
        element.start_date = moment(element.start_date).format('DD-MM-YYYY');
        element.end_date = moment(element.end_date).format('DD-MM-YYYY');
      }
      // console.log(`sortedArray`, { sortedArray });
      // ProgramDetails.value = sortedArray;
      filteredProgramDetails.value = sortedArray;
      renderReady.value = true;
    };
    const getAllPrograms = async () => {
      renderReady.value = false;
      programLists.value = await invokegetAllProgram('/cache?cache=program');
      // console.log(programDetails.value);
      renderReady.value = true;
    };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const showProgramDetailsBtn = (event: any, programId: any, participants: any, programName: any) => {
      const cb = event.target.checked;
      if (cb === true) {
        programBtnShow.value = true;
        selectedProgramId.value = programId;
        participantList.value = participants;
        selectedProgramName.value = programName;
        if (userRole.value.includes('System Admin') && programId !== 'infinity') {
          showTriggerProxyAssignment.value = true;
        }
        if (userRole.value.includes('Program Admin') || userRole.value.includes('System Admin')) {
          edcastBtnShow.value = true;
          // showTaskImport.value = true;
          if (selectedProgramId.value === 'infinity' || selectedProgramId.value === 'S2') {
            showReportBtn.value = false;
            showBulkBtn.value = false;
          } else {
            showReportBtn.value = true;
            showBulkBtn.value = true;
          }
        }
      } else {
        programBtnShow.value = false;
        edcastBtnShow.value = false;
      }
    };
    const getEdcastUrl = async () => {
      renderReady.value = false;
      await getEdcaseURL(selectedProgramId.value, selectedProgramName.value);
      renderReady.value = true;
    };
    const viewParticipant = async () => {
      showParticipant.value = true;
    };
    const closeModal = async () => {
      showParticipant.value = false;
      programCheckOne.value = [];
      programBtnShow.value = false;
      // await getProgramDetails();
      await searchPrograms();
    };
    const viewProgramDetails = () => {
      const routeData = router.resolve({ name: 'SolidifyAdministrationProgramDetails', query: { program_id: selectedProgramId.value } });
      window.open(routeData.href, '_blank');
      // router.push({ path: 'programDetails', query: { program_id: selectedProgramId.value } });
    };
    const triggerReport = async () => {
      renderReady.value = false;
      const reportResponse = await invokeTriggerReport(selectedProgramId.value);
      reportSuccessMessage.value = 'The report will be emailed to you';
      setTimeout(() => {
        reportSuccessMessage.value = null;
      }, 6000);
      console.log(`Report Trigger Response ${reportResponse}`);
      renderReady.value = true;
    };

    const triggerProxyAssignmentForCohort = async () => {
      try {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const res: any = await triggerProxyAssignmentForSpecialProgram(selectedProgramId.value);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const triggerRes: any = res.data;
        reportSuccessMessage.value = triggerRes.message;
        setTimeout(() => {
          reportSuccessMessage.value = null;
        }, 6000);
        console.log(`Report Trigger Response ${JSON.stringify(triggerRes)}`);
      } catch (error) {
        renderReady.value = true;
        console.log(`error peer review ${error}`);
        // localStorage.setItem('errorMsg', 'There is an issue while fetching peer learner task to review, please contact with helpmate');
        // router.push({ path: 'Error' });
        if (axios.isAxiosError(error)) {
          const err = error as AxiosError;
          // console.log(err.response?.data);
          renderReady.value = true;
          errorMessage.value = (err.response?.data as { message: string })?.message;
          // console.log(`errorMessage.value ${errorMessage.value}`);
          setTimeout(() => {
            errorMessage.value = null;
          }, 2000);
        }
      }
    };
    // const getFilteredList = (value) => {
    //   // filteredProgramDetails.value = value;
    //   // console.log('ProgramDetails.value in final', ProgramDetails.value);
    //   filteredProgramDetails.value = ProgramDetails.value.filter((program) => value.includes(program.program_name));
    //   console.log('filteredProgramDetails', filteredProgramDetails.value);
    // };
    const manageEmailTemplates = () => {
      router.push({ name: 'SolidifyAdministrationManageEmailTemplates', query: { program_id: selectedProgramId.value } });
    };
    const searchPrograms = async () => {
      // await getProgramDetails();
      console.log('programLists.value', programLists.value);
      programIdsArr.value = programLists.value.filter((program) => program.program_name.toLowerCase().includes(searchProgText.value.toLowerCase()));
      console.log(`ProgramIdsArr`, { data: programIdsArr.value });
      await getSelectedProgramDetails();
    };
    onBeforeMount(async () => {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      const role: any = await invokeGetUserRole('/getUserRole');
      loggedInUser.value = role.user_key;
      userRole.value = role.user_roles;
      if (userRole.value.length > 0) {
        if (userRole.value.includes('Program Admin') || userRole.value.includes('System Admin') || userRole.value.includes('System Admin View Access')) {
          showScreen.value = true;
        } else {
          showScreen.value = false;
        }
        // await getProgramDetails();
        await getAllPrograms();
      }

      // console.log('ProgramDetailsArray.value', ProgramDetailsArray.value);
    });
    return {
      openShareModal,
      openShareModalParticipant,
      // ProgramDetails,
      renderReady,
      programCheckOne,
      checkOne,
      selectedProgramId,
      showProgramDetailsBtn,
      programBtnShow,
      viewParticipant,
      showParticipant,
      participantList,
      closeModal,
      viewProgramDetails,
      selectedProgramName,
      getEdcastUrl,
      showBulkParticipantPanel,
      selectedFile,
      clearFile,
      bulkParticipantsFile,
      errorMessage,
      // bulkImportParticipants,
      showScreen,
      userRole,
      loggedInUser,
      fileInputKey,
      successMessage,
      showReportBtn,
      showTaskImport,
      triggerReport,
      edcastBtnShow,
      showBulkBtn,
      reportSuccessMessage,
      triggerProxyAssignmentForCohort,
      showTriggerProxyAssignment,
      // moment,
      filteredProgramDetails,
      // getFilteredList,
      ProgramDetailsArray,
      manageEmailTemplates,
      searchPrograms,
      searchProgText,
    };
  },
});
